import { render } from "./turn.vue?vue&type=template&id=6cc0abf0"
import script from "./turn.vue?vue&type=script&lang=js"
export * from "./turn.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/geramyan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__